import { TemplateItem } from "types";
import { CustomText, TitleItem } from "../../../types";
import { DEFAULT_TITLE_CONTENT } from "../../../constants";
import { mapToServerColor } from "../../itemsHelper";

export const generateTextGraphics = (
  textItem: CustomText | TitleItem
): TemplateItem["graphics"] => {
  const {
    fontAssetId,
    fontSize,
    color,
    backgroundColor,
    textAlign,
    strokeColor,
    verticalAlign,
    lineHeight,
  } = textItem;
  const content =
    "content" in textItem ? textItem.content : DEFAULT_TITLE_CONTENT;
  return {
    type: "Text",
    font: fontAssetId ?? "{brand_kit.title_font.asset_id}",
    size: fontSize,
    color: mapToServerColor(color ?? "#000000"),
    content: content,
    wrap_text: true,
    upper_case: false,
    align: textAlign,
    adjust_font: true,
    background: backgroundColor ? mapToServerColor(backgroundColor) : null,
    stroke_color: strokeColor ? mapToServerColor(strokeColor) : null,
    vertical_align: verticalAlign ?? "top",
    line_spacing: lineHeight,
  };
};
